import { useMutation } from '@apollo/client'
import { CheckOldPassword as CheckOldPasswordMutation } from '../../types'
import { CHECK_USER_OLD_PASSWORD } from './operations'

export const useCheckOldPassword = () => useMutation<CheckOldPasswordMutation>(CHECK_USER_OLD_PASSWORD)
